/* ANYSNIFF lightbox
 * Drop-in replacement for Webflow's lightbox runtime.
 * Builds the exact DOM the .w-lightbox-* rules in anysniff-shared.css expect,
 * so the visual result is the stock Webflow lightbox without webflow.js.
 * Markup contract (unchanged from Webflow): <a class="w-lightbox"> containing
 * <script type="application/json" class="w-json">{ items:[{url,type,caption}] }</script>
 */
(function () {
  "use strict";

  var html = document.documentElement;
  var open = null; // { backdrop, items, index }

  function el(tag, cls, parent) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (parent) parent.appendChild(n);
    return n;
  }

  function readItems(link) {
    var json = link.querySelector('script.w-json');
    if (!json) return [];
    try {
      var data = JSON.parse(json.textContent);
      return Array.isArray(data.items) ? data.items : [];
    } catch (e) {
      return [];
    }
  }

  function lockScroll(lock) {
    html.classList.toggle('w-lightbox-noscroll', lock);
    if (window.lenis) lock ? window.lenis.stop() : window.lenis.start();
  }

  function show(index) {
    if (!open) return;
    var n = open.items.length;
    open.index = (index + n) % n;
    open.views.forEach(function (v, i) {
      v.style.opacity = i === open.index ? '1' : '0';
      v.style.pointerEvents = i === open.index ? 'auto' : 'none';
    });
    open.thumbs.forEach(function (t, i) {
      t.classList.toggle('w-lightbox-active', i === open.index);
    });
  }

  function close() {
    if (!open) return;
    var backdrop = open.backdrop;
    backdrop.style.opacity = '0';
    lockScroll(false);
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { backdrop.remove(); }, 200);
    open = null;
  }

  function onKey(e) {
    if (!open) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(open.index - 1);
    else if (e.key === 'ArrowRight') show(open.index + 1);
  }

  function build(items, startIndex) {
    var group = items.length > 1;

    var backdrop = el('div', 'w-lightbox-backdrop', document.body);
    backdrop.style.transition = 'opacity 200ms ease';
    var container = el('div', 'w-lightbox-container', backdrop);
    var content = el('div', 'w-lightbox-content' + (group ? ' w-lightbox-group' : ''), container);

    var views = items.map(function (item) {
      var view = el('div', 'w-lightbox-view', content);
      view.style.transition = 'opacity 200ms ease';
      var frame = el('div', 'w-lightbox-frame', view);
      var figure = el('figure', 'w-lightbox-figure', frame);

      if (item.type === 'video' && item.html) {
        var embed = el('div', 'w-lightbox-embed', figure);
        embed.innerHTML = item.html;
      } else {
        var img = el('img', 'w-lightbox-img w-lightbox-image', figure);
        img.src = item.url;
        if (item.width) img.width = item.width;
        if (item.height) img.height = item.height;
        img.alt = item.caption || '';
      }
      if (item.caption) {
        el('figcaption', 'w-lightbox-caption', figure).textContent = item.caption;
      }
      return view;
    });

    var thumbs = [];
    if (group) {
      var strip = el('div', 'w-lightbox-strip', content);
      items.forEach(function (item, i) {
        var a = el('a', 'w-lightbox-item w-inline-block', strip);
        a.setAttribute('role', 'button');
        a.setAttribute('aria-label', 'open lightbox');
        var thumb = el('div', 'w-lightbox-thumbnail', a);
        var timg = el('img', 'w-lightbox-thumbnail-image', thumb);
        timg.src = item.thumbnailUrl || item.url;
        // Webflow sizes the thumbnail by orientation
        timg.classList.add((item.width || 0) > (item.height || 0) ? 'w-lightbox-wide' : 'w-lightbox-tall');
        a.addEventListener('click', function (e) { e.stopPropagation(); show(i); });
        thumbs.push(a);
      });
    }

    var left = el('div', 'w-lightbox-control w-lightbox-left' + (group ? '' : ' w-lightbox-inactive'), container);
    var right = el('div', 'w-lightbox-control w-lightbox-right' + (group ? '' : ' w-lightbox-inactive'), container);
    var closeBtn = el('div', 'w-lightbox-control w-lightbox-close', container);

    left.addEventListener('click', function (e) { e.stopPropagation(); show(open.index - 1); });
    right.addEventListener('click', function (e) { e.stopPropagation(); show(open.index + 1); });
    closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    backdrop.addEventListener('click', close);
    content.addEventListener('click', function (e) { e.stopPropagation(); });

    open = { backdrop: backdrop, items: items, views: views, thumbs: thumbs, index: 0 };
    show(startIndex || 0);
    lockScroll(true);
    document.addEventListener('keydown', onKey);
    // next frame so the opacity transition runs
    requestAnimationFrame(function () { backdrop.style.opacity = '1'; });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.w-lightbox') : null;
    if (!link) return;
    var items = readItems(link);
    if (!items.length) return;
    e.preventDefault();
    build(items, 0);
  });
})();
